import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import styled from "styled-components/macro";

import BoardsAPI from "Boards/API";
import { useBoards } from "Boards/BoardContext";
import Table from "Boards/Table";
import { BOARD_TYPES } from "Boards/const";
import { useSignups } from "Signups/state";

import FnrLoadingCarousel from "UI/FnrLoadingCarousel";

import BoardError from "./BoardError";
import "./SignupBoardFilterPanelStyles.css";

export default function SignupBoard() {
  const { signupTab } = useParams();
  const [, dispatch] = useBoards();
  const [{ currentSignupList }] = useSignups();
  const signupListID = currentSignupList.ID;
  const [fetchStatus, setFetchStatus] = useState(null);

  useEffect(() => {
    window.fnReactBus.loadSheetsResources();
  }, []);

  useEffect(() => {
    if (signupTab !== "respondents") return; // Only fetch data if they are on the relevant tab
    setFetchStatus("loading");
    dispatch({ type: "clearBoardData" });

    const getBoardCall = BoardsAPI.getSignupBoard({ signupListID });

    getBoardCall
      .post()
      .then((boardData) => {
        dispatch({ type: "setBoardType", payload: BOARD_TYPES.SIGNUP });
        dispatch({ type: "setBoardData", payload: boardData });
        setFetchStatus("success");
      })
      .catch(() => {
        setFetchStatus("error");
      });

    return () => {
      window.fnReactBus.removeFiltersPanelObj();
      dispatch({ type: "Filter Panel Closed" });
      getBoardCall.cancel();
    };
  }, [signupTab, dispatch, signupListID]);

  const renderContent = () => {
    if (fetchStatus === "loading") {
      return <FnrLoadingCarousel show={true} />;
    } else if (fetchStatus === "error") {
      return <BoardError />;
    } else if (fetchStatus === "success") {
      return <Table />;
    }

    return null;
  };

  return (
    <Wrapper className="page group_panel page_sheet on">
      {renderContent()}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  top: 0;
  bottom: 0;
  background: #fff;
`;
